import { initReactI18next } from "react-i18next";

import { syncDocumentLang } from "@/utils/i18n-locale";

import i18n from "i18next";
// For lazy loading for translations: https://github.com/i18next/i18next-http-backend
import detector from "i18next-browser-languagedetector";
// https://react.i18next.com/latest/using-with-hooks
import Backend from "i18next-http-backend";

import { i18nOptions } from "./i18n-options";

// For auto detecting the user language: https://github.com/i18next/i18next-browser-languageDetector

export const i18nInitPromise = i18n.use(Backend).use(detector).use(initReactI18next).init(i18nOptions);

// Keep <html lang> in step with the active language for assistive tech.
i18n.on("languageChanged", syncDocumentLang);
i18nInitPromise.then(() => syncDocumentLang(i18n.language));

export default i18n;
